if (!customElements.get('gcp-search-collection-browser')) {
  // Intentionally not registered: the collection browser is a <details> element for native accessibility.
}

document.addEventListener('click', (event) => {
  document.querySelectorAll('.gcp-search-collections[open]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.gcp-search-collections[open]').forEach((details) => {
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.focus();
  });
});
